import React from 'react';

/**
 * SkipNav — WCAG 2.1 AA skip navigation link.
 * Visible only on keyboard focus so it doesn't clutter the visual design.
 * Add <SkipNav /> as the very first element inside Layout.
 */
const SkipNav = () => (
  <>
    <a
      href="#main-content"
      style={{
        position: 'absolute',
        top: '-50px',
        left: '16px',
        background: '#1a1a18',
        color: '#ffffff',
        padding: '10px 16px',
        borderRadius: '0 0 6px 6px',
        fontSize: '14px',
        fontWeight: '600',
        textDecoration: 'none',
        zIndex: 9999,
        transition: 'top 0.2s',
      }}
      onFocus={e => { e.target.style.top = '0'; }}
      onBlur={e => { e.target.style.top = '-50px'; }}
    >
      Skip to main content
    </a>
    <a
      href="#main-nav"
      style={{
        position: 'absolute',
        top: '-50px',
        left: '200px',
        background: '#1a1a18',
        color: '#ffffff',
        padding: '10px 16px',
        borderRadius: '0 0 6px 6px',
        fontSize: '14px',
        fontWeight: '600',
        textDecoration: 'none',
        zIndex: 9999,
        transition: 'top 0.2s',
      }}
      onFocus={e => { e.target.style.top = '0'; }}
      onBlur={e => { e.target.style.top = '-50px'; }}
    >
      Skip to navigation
    </a>
  </>
);

export default SkipNav;
